<template>
    <v-container container--fluid>
        <v-layout row wrap align-center justify-space-around class="pa-2 mx-auto">
            <v-flex xs12 class="text-left">
                <h1 class="grey--text lighten-3 mb-2">Local Roster</h1>

                <v-overlay :value="loading">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                </v-overlay>
                <v-row>
                    <v-col cols="12" sm="6" md="4">
                        <v-autocomplete
                            :loading="loading"
                            item-text="event_name"
                            item-value="event_id"
                            v-model.trim="sel_event"
                            :items="events"
                            label="Events"
                            hint="Select an Event"
                            persistent-hint
                            outlined
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <v-menu v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field outlined v-model="computedDateFormatted" label="Roster Date" prepend-inner-icon="event" readonly v-on="on"></v-text-field>
                            </template>
                            <v-date-picker no-title scrollable v-model="roster_date" @input="menu = false"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                        <v-btn block class="btnShowRoster" :loading="loading" color="primary" @click="getRoster">MY ROSTER<v-icon right>schedule</v-icon></v-btn>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                        <v-btn block class="btnShowRoster" :loading="loading" color="primary" @click="getFullRoster">FULL ROSTER<v-icon right>schedule</v-icon></v-btn>
                    </v-col>
                </v-row>

                <div v-if="roster.roster && showRoster">
                    <v-row v-for="(event, index) in roster.roster" :key="index">
                        <div class="col mt-4 round-wrapper pa-0">
                            <v-col cols="12">
                                <v-flex>
                                    <v-card class="d-flex flex-column pa-3 mb-1 draw-card" raised>
                                        <div class="text-center mb-2"><v-icon color="primary" left>calendar_today</v-icon> {{ event.schedule_date_formatted }}</div>
                                        <div class="text-center mb-2"><v-icon color="primary" left class="mx-1">location_on</v-icon> {{ event.venue_name }}</div>
                                        <div class="text-center">{{ event.event_name }}</div>
                                        <div class="text-center"><b>Function:</b> {{ event.function }}</div>
                                        <v-divider class="my-3"></v-divider>
                                        <div class="d-flex justify-space-around mb-3 flex-basis-third">
                                            <div class="text-center font-weight-bold mobile">
                                                {{ event.schedule_time_formatted }} <v-icon color="primary" left right class="mx-1 mt-n1">alarm</v-icon> {{ event.court_name }}
                                            </div>
                                        </div>
                                        <v-divider class="my-3"></v-divider>
                                        <div class="text-center" v-if="isFutureDate(event)">
                                            <v-btn color="secondary" :href="genGoogLinkCal(event)" target="_blank" class="btnCal ma-2"><i class="fas fa-calendar-plus pr-2"></i>Add to Google Calendar</v-btn>
                                            <v-btn color="primary" @click="genICal(event)" class="btnCal my-2"><i class="fas fa-calendar-plus pr-2"></i>Add to Apple Calendar</v-btn>
                                        </div>
                                    </v-card>
                                </v-flex>
                            </v-col>
                        </div>
                    </v-row>
                </div>
                <div v-if="roster.full_roster && showFullRoster">
                    <div class="col mt-4 round-wrapper pa-0" v-html="roster.full_roster"></div>
                </div>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import store from "@modules/roster/_store";
import moment from "moment";
import { downloadIcs, googleCalendarUrl } from "@shared/calendar";

export default {
    name: "roster",
    data() {
        return {
            sel_event: null,
            roster_date: moment().format("YYYY-MM-DD"),
            menu: false,
            showRoster: false,
            showFullRoster: false,
        };
    },
    computed: {
        computedDateFormatted() {
            return this.roster_date ? moment(this.roster_date).format("DD/MM/YYYY") : "";
        },
        loading() {
            return this.$store.getters["roster/rosterStatus"] == "loading";
        },
        events() {
            return this.$store.getters["roster/events"];
        },
        roster() {
            return this.$store.getters["roster/roster"];
        },
    },
    methods: {
        isFutureDate(event) {
            return moment(event.schedule_date+' '+event.schedule_time).isAfter();
        },
        getRoster() {
            if (this.sel_event && this.roster_date) {
                const { sel_event, roster_date } = this;

                this.$store.dispatch("roster/getRoster", { sel_event, roster_date });
                this.showRoster = true;
                this.showFullRoster = false;
            }
        },
        getFullRoster() {
            if (this.sel_event && this.roster_date) {
                const { sel_event, roster_date } = this;

                this.$store.dispatch("roster/getRoster", { sel_event, roster_date });
                this.showRoster = false;
                this.showFullRoster = true;
            }
        },
        calendarEvent(event) {
            let start = moment(event.schedule_date + " " + event.schedule_time, "Y-M-D HH:mm:ss");
            let duration = parseInt(event.duration_minutes) || 0;
            // Only set an end time when we actually know the duration; never assume one.
            let durationText = duration > 0 ? " (" + duration + " mins)" : "";

            return {
                uid: event.event,
                title: this.appNameUrls.client + " - Local Roster",
                start: start,
                end: duration > 0 ? start.clone().add(duration, "minutes") : null,
                location: event.venue_name,
                descriptionLines: [
                    event.event_name,
                    event.court_name + " @ " + event.schedule_time_formatted + durationText + " on " + event.schedule_date_formatted,
                ],
                timezone: this.lmpTz,
                filename: "local-roster.ics",
            };
        },
        genGoogLinkCal(event) {
            return googleCalendarUrl(this.calendarEvent(event));
        },
        genICal(event) {
            downloadIcs(this.calendarEvent(event));
        },
    },
    beforeCreate() {
        this.$store.dispatch("roster/getEvents");

        // if(_.isEmpty(this.$store.getters['roster/roster'])){
        //     this.$store.dispatch('roster/getRoster');
        // }
    },
};
</script>

<style lang="scss">
.roster-card {
    &:hover {
        background-color: var(--drawer-color) !important;
        border-color: var(--drawer-color) !important;
        color: #fff !important;
        caret-color: #fff !important;
    }
}
.flex-basis-third {
    div {
        flex: 1 1 33.33%;
    }
}
.round-wrapper {
    .col.col-12 .flex:nth-of-type(n + 2) .bye-duty-team {
        display: none !important;
    }
}

.v-text-field__slot {
    input {
        border: none !important;
    }
}

.btnShowRoster {
    min-height: 56px;
}

#roster_table {
    width: 100%;
    border-spacing: 0px;
    font-size: 14px;

    thead {
        th {
            padding: 10px 5px;
            font-weight: bold;
            color: #fff;
            background: var(--primary-color) !important;
            text-align: left !important;
        }
    }

    tr {
        &:nth-child(even) {
            // background: #fff;
        }

        &:nth-child(odd) {
            // background: #e0e0e0;
        }

        td {
            padding: 10px 5px;
            text-align: left !important;
            max-width: 100px;

            span.mob_title,
            span.mob_title_landscape {
                display: none;
            }
        }
    }
}

@media screen and (max-width: 767px) {
    .btnCal {
        min-width: 100% !important;
    }

    #roster_table {
        thead.portrait,
        thead.landscape {
            display: none !important;
        }

        tr {
            border-bottom: 1px solid #000 !important;
            display: block;
        }

        th,
        td {
            display: block !important;
            max-width: unset !important;

            span.mob_title {
                display: inline-block !important;
                font-weight: bold;
            }

            span.mob_title_landscape {
                display: block !important;
                font-weight: bold;
            }

            br {
                display: none;
            }
        }
    }
}
</style>
